import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class SCTHApiSetting
 *
 * @property {number} id
 */
export class SCTHApiSetting extends Model {


}

AccessorsMutatorsDecorator('id', 'property_id', 'api_key', 'user_name', 'password', 'is_active')(SCTHApiSetting);



// WEBPACK FOOTER //
// ./src/pms-api/models/scth-api-setting.model.js